export default __webpack_public_path__ + "static/media/33.0d8bfae4.jpg";